import type { GQLLocale } from 'graphql-ts-types';
import { SubscriptionChannel, SubscriptionState, SubscriptionType } from 'graphql-ts-types';

import type { BirthDayFieldValue } from 'common/components/Form/BirthdayField/types';
import { formatBirthDateIntoGqlInput } from 'common/components/Form/BirthdayField/utils';
import type { Translate } from 'common/providers/LocaleProvider';
import {
  dispatchHomeClubSectionClickEvent,
  HomeClubSectionEventElement,
  HomeClubSectionEventInteraction,
  HomeClubSectionEventPlacement,
} from 'common/tracking/home-club';
import { performSubscribeHomeClubNewsletter, performUpdateBirthdate } from './mutations';

interface SubmitBirthdayFormArgs {
  t: Translate;
  locale: GQLLocale;
  birthday: BirthDayFieldValue;
  setErrorMessage: (errorMessage: string) => void;
  setSuccessMessage: (text: string) => void;
  withHomeClubCheckbox?: boolean;
}

export const submitBirthdayForm = async ({
  t,
  locale,
  birthday,
  setErrorMessage,
  setSuccessMessage,
  withHomeClubCheckbox,
}: SubmitBirthdayFormArgs) => {
  setErrorMessage(null);

  try {
    const birthdate = formatBirthDateIntoGqlInput(birthday);
    const subscriptions = [
      {
        type: SubscriptionType.HomeClubNewsletter,
        channel: SubscriptionChannel.Email,
        state: SubscriptionState.Confirmed,
      },
    ];

    const birthdateMutationPromise = performUpdateBirthdate({ birthdate });
    const subscriptionsMutationPromise = withHomeClubCheckbox
      ? performSubscribeHomeClubNewsletter({ subscriptions, locale })
      : Promise.resolve();

    await Promise.all([birthdateMutationPromise, subscriptionsMutationPromise]);

    setSuccessMessage(t('h24_hc_birthday_success_msg'));
    dispatchHomeClubSectionClickEvent({
      element: HomeClubSectionEventElement.Button,
      button_text: t('h24_save'),
      interaction: HomeClubSectionEventInteraction.SaveBirthday,
      placement: HomeClubSectionEventPlacement.Inline,
    });
  } catch {
    setErrorMessage(t('h24_something_went_wrong'));
  }
};
